class ProductCardSwatches extends HTMLElement {
  constructor() {
    super();
    this.handleSwatchClick = this.onSwatchClick.bind(this);
  }

  connectedCallback() {
    try {
      var jsonEl = this.querySelector('.product-card-variants');
      if (!jsonEl) return;
      this.variantData = JSON.parse(jsonEl.textContent);
    } catch (e) {
      console.error('ProductCardSwatches: Failed to parse variant JSON', e);
      return;
    }

    this.swatches = this.querySelectorAll('.product-swatch');
    this.swatches.forEach(function (swatch) {
      swatch.addEventListener('click', this.handleSwatchClick);
    }.bind(this));
  }

  disconnectedCallback() {
    if (this.swatches) {
      this.swatches.forEach(function (swatch) {
        swatch.removeEventListener('click', this.handleSwatchClick);
      }.bind(this));
    }
  }

  onSwatchClick(e) {
    e.preventDefault();
    e.stopPropagation();

    var card = this.closest('.product-card');
    if (!card) return;

    var swatchContainer = this.querySelector('.product-swatches');
    if (!swatchContainer) return;

    var optionPosition = parseInt(swatchContainer.dataset.optionPosition, 10);
    var optionKey = 'option' + optionPosition;
    var colorValue = e.currentTarget.dataset.colorValue;

    // Find first available variant with this color, fallback to first match
    var variant = this.variantData.find(function (v) {
      return v[optionKey] === colorValue && v.available;
    });
    if (!variant) {
      variant = this.variantData.find(function (v) {
        return v[optionKey] === colorValue;
      });
    }
    if (!variant) return;

    // 1. Update active swatch
    this.swatches.forEach(function (s) { s.classList.remove('product-swatch--active'); });
    e.currentTarget.classList.add('product-swatch--active');

    // 2. Update variant ID hidden input
    var variantInput = card.querySelector('input[name="id"]');
    if (variantInput) variantInput.value = variant.id;

    // 3. Update product URLs
    var baseUrl = card.querySelector('.product-card__image-link').dataset.baseUrl;
    var variantUrl = baseUrl + '?variant=' + variant.id;
    var imageLink = card.querySelector('.product-card__image-link');
    var titleLink = card.querySelector('.product-card__title-link');
    if (imageLink) imageLink.href = variantUrl;
    if (titleLink) titleLink.href = variantUrl;

    // 4. Update primary image
    if (variant.featured_image) {
      var img = card.querySelector('.product-image-container img.responsive-image');
      if (img) {
        img.src = variant.featured_image.src;
        img.setAttribute('data-src', variant.featured_image.data_src);
        img.setAttribute('data-srcset', variant.featured_image.srcset);
        img.setAttribute('alt', variant.featured_image.alt);
        img.setAttribute('width', variant.featured_image.width);
        img.setAttribute('height', variant.featured_image.height);
        // Re-trigger lazysizes
        img.classList.remove('lazyloaded');
        img.classList.add('lazyload');
      }
    }

    // 5. Update sold-out state
    var overlay = card.querySelector('[data-sold-out-overlay]');
    var badge = card.querySelector('[data-sold-out-badge]');
    if (overlay) overlay.style.display = variant.available ? 'none' : '';
    if (badge) badge.style.display = variant.available ? 'none' : '';

    // 6. Update price
    var priceContainer = card.querySelector('[data-price-container]');
    if (priceContainer) {
      var html = '';
      if (variant.compare_at_price_formatted) {
        html += '<div class="product-price-container-content">';
        html += '<span class="product-price" style="color: var(--color-price-foreground); font-weight: 500;">' + variant.price_formatted + '</span>';
        html += '<s class="compare-at-price">' + variant.compare_at_price_formatted + '</s>';
        html += '</div>';
      } else {
        html += '<div class="product-price-container-content">';
        html += '<span class="product-price">' + variant.price_formatted + '</span>';
        html += '</div>';
      }

      var showPromo = priceContainer.dataset.showPromo === 'true';
      if (showPromo && variant.discount_percentage > 0) {
        html += '<div class="product-discounted-promo"><span>' + variant.discount_percentage + '% off</span></div>';
      } else if (showPromo) {
        html += '<div class="product-discounted-promo"></div>';
      }

      priceContainer.innerHTML = html;
    }

    // 7. Update add-to-cart button
    var atcButton = card.querySelector('add-to-cart button');
    if (atcButton) {
      var atcText = atcButton.querySelector('.atc-button__text');
      if (variant.available) {
        atcButton.disabled = false;
        if (atcText) atcText.textContent = 'ADD TO CART';
      } else {
        atcButton.disabled = true;
        if (atcText) atcText.textContent = 'SOLD OUT';
      }
    }
  }
}

customElements.define('product-card-swatches', ProductCardSwatches);
